import apiClient from "@/services/apiClient";

/**
 * Public, read-only reads of the three admin-curated/auto-curated course lists (see the
 * backend's course_collections table): "Learners Favourite" (navbar search dropdown, 9 courses),
 * "Trending Courses" (navbar dropdown + homepage carousel, 15 courses), and "Featured Courses"
 * (homepage "Start learning today, for free" section, 8 courses). No auth required -- these
 * back anonymous-visitor surfaces, so they just read whatever is currently curated, ordered by
 * position.
 */

export async function getLearnersFavouriteCollection() {
  const { data } = await apiClient.get("/public/collections/learners-favourite");
  return data;
}

export async function getTrendingCollection() {
  const { data } = await apiClient.get("/public/collections/trending");
  return data;
}

export async function getFeaturedCollection() {
  const { data } = await apiClient.get("/public/collections/featured");
  return data;
}
